import { Reveal } from "./Reveal";
import { useLang } from "../config/i18n";

export const ComoFunciona = () => {
  const { t } = useLang();

  return (
    <section data-testid="process-section" className="relative py-24 sm:py-36 bg-[#121216] border-y border-[#22222B]">
      <div className="max-w-6xl mx-auto px-6">
        <Reveal>
          <p className="text-[11px] font-semibold tracking-[0.3em] text-[#C5A059] uppercase mb-5">{t.process.overline}</p>
          <h2 className="font-heading text-3xl sm:text-4xl text-[#F7F7F8] leading-snug mb-16">{t.process.title}</h2>
        </Reveal>
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4 relative">
          <div className="hidden lg:block absolute top-7 left-[12%] right-[12%] h-px bg-gradient-to-r from-transparent via-[#C5A059]/35 to-transparent" />
          {t.process.steps.map(({ n, title, text }, i) => (
            <Reveal key={n} delay={i * 0.12}>
              <div data-testid={`step-${i + 1}`} className="relative">
                <span className="font-heading text-5xl gold-text font-light block mb-5">{n}</span>
                <span className="hidden lg:block absolute top-6 -left-1 w-2.5 h-2.5 rotate-45 bg-[#C5A059]" />
                <h3 className="text-sm font-semibold tracking-[0.2em] uppercase text-[#F7F7F8] mb-3">{title}</h3>
                <p className="text-sm text-[#A3A3AF] leading-relaxed font-light">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
